import React from "react";
import { ArrowRight } from "lucide-react";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/a9778dd3-cc77-4862-94cf-6a30e83d1c8c/images/92649c30fb8195c6e2cf37183ce091f5570bd6f52a7e5b54ec32fe7a1d139edb.png";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-screen flex items-center overflow-hidden bg-navy"
        >
            {/* Background image */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${HERO_BG})` }}
            />
            <div className="absolute inset-0 bg-navy/82" />
            {/* Subtle grain */}
            <div
                className="absolute inset-0 opacity-[0.06] mix-blend-overlay pointer-events-none"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence baseFrequency='0.9' /></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.6'/></svg>\")",
                }}
            />

            {/* Gold vertical line */}
            <div className="absolute top-0 bottom-0 left-10 lg:left-24 w-px bg-gold/30 hidden md:block" />

            <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-20 w-full">
                <div className="max-w-4xl animate-fade-up">
                    <div className="flex items-center gap-4 mb-8">
                        <span className="block w-16 h-[2px] bg-gold" />
                    </div>

                    <h1 className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] leading-[1.02] tracking-tight mb-6">
                        Avv. Marco<br />
                        <span className="italic text-gold">Candido</span>
                    </h1>

                    <p className="font-serif text-white/90 text-xl md:text-2xl lg:text-3xl leading-snug mb-8 max-w-3xl">
                        Consulenza ai lavoratori e alle imprese in materia di
                        <span className="text-gold italic"> diritto del lavoro</span>.
                    </p>

                    <p className="text-slate-200 text-base md:text-lg leading-relaxed max-w-2xl mb-12 font-light">
                        Lo Studio offre a lavoratori e imprese, in tutta Italia, assistenza stragiudiziale qualificata su tematiche giuslavoristiche, sindacali e previdenziali, nonché assistenza giudiziale con l'ausilio di colleghi esperti in materia. L'approccio è rigoroso, riservato e orientato al risultato.
                    </p>

                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                        <a
                            href="#contatti"
                            data-testid="hero-cta-contact"
                            className="btn-gold group"
                        >
                            Richiedi un appuntamento
                            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                        </a>
                        <a
                            href="#aree"
                            data-testid="hero-cta-areas"
                            className="inline-flex items-center gap-2 px-7 py-3 border border-white/30 text-white font-semibold tracking-wide uppercase text-sm transition-all duration-300 hover:border-gold hover:text-gold"
                        >
                            Scopri le aree di competenza
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom decoration */}
            <div className="absolute bottom-0 right-0 hidden lg:block">
                <div className="text-[180px] font-serif text-white/[0.025] leading-none pr-10 pb-4 select-none">
                    Lex
                </div>
            </div>
        </section>
    );
}
